import api from './api';

const customerJourneyService = {
  // 旅程管理
  getJourneyList: (params = {}) => {
    return api.get('/customer-journey', { params });
  },

  getJourneyById: (id) => {
    return api.get(`/customer-journey/${id}`);
  },

  getJourneyWithNodes: (id) => {
    return api.get(`/customer-journey/${id}/with-nodes`);
  },

  createJourney: (data) => {
    return api.post('/customer-journey', data);
  },

  updateJourney: (id, data) => {
    return api.put(`/customer-journey/${id}`, data);
  },

  deleteJourney: (id) => {
    return api.delete(`/customer-journey/${id}`);
  },


  checkJourneyCode: (journeyCode, excludeId = null) => {
    return api.get('/customer-journey/check-code', {
      params: { journeyCode, excludeId }
    });
  },

  getAllJourneys: () => {
    return api.get('/customer-journey/all');
  },

  syncJourneyToWework: (id) => {
    return api.post(`/customer-journey/${id}/sync`);
  },

  batchSyncJourneysToWework: (journeyIds) => {
    return api.post('/customer-journey/batch-sync', journeyIds);
  },

  // 节点管理
  getNodesByJourneyId: (journeyId) => {
    return api.get(`/customer-journey/nodes/journey/${journeyId}`);
  },

  getNodeById: (id) => {
    return api.get(`/customer-journey/nodes/${id}`);
  },

  createNode: (data) => {
    return api.post('/customer-journey/nodes', data);
  },

  updateNode: (id, data) => {
    return api.put(`/customer-journey/nodes/${id}`, data);
  },

  deleteNode: (id) => {
    return api.delete(`/customer-journey/nodes/${id}`);
  },

  moveNode: (id, newOrder) => {
    return api.post(`/customer-journey/nodes/${id}/move`, null, {
      params: { newOrder }
    });
  },

  updateNodeOrders: (journeyId, nodeIds) => {
    return api.post(`/customer-journey/nodes/journey/${journeyId}/reorder`, nodeIds);
  },

  activateNode: (id) => {
    return api.post(`/customer-journey/nodes/${id}/activate`);
  },

  deactivateNode: (id) => {
    return api.post(`/customer-journey/nodes/${id}/deactivate`);
  },

  checkNodeCode: (journeyId, nodeCode, excludeId = null) => {
    return api.get('/customer-journey/nodes/check-code', {
      params: { journeyId, nodeCode, excludeId }
    });
  },

  syncNodeToWework: (id) => {
    return api.post(`/customer-journey/nodes/${id}/sync`);
  },

  batchSyncNodesToWework: (nodeIds) => {
    return api.post('/customer-journey/nodes/batch-sync', nodeIds);
  }
};

export default customerJourneyService;